<script setup lang="ts">
import { computed } from 'vue';
import KkIcon from '@/component/kk-icon/index.vue';

// 由于Vue setup中不支持import类型，所以需要重复声明props类型
interface KKToastProps {
  content: string;
  /** 默认 success */
  type?: 'success' | 'warn' | 'error';
  /** 出现时长，单位ms，默认3000 */
  duration?: number;
}
const props = withDefaults(defineProps<KKToastProps>(), {
  content: '',
  type: 'success',
  duration: 3000,
});

const iconNameMap = {
  success: 'success-green',
  warn: 'warn-yellow',
  error: 'error-red',
};

const iconName = computed(() => iconNameMap[props.type]);

</script>

<template>
  <div
    class="ui-kk-toast"
  >
    <kk-icon :name="iconName" />
    <div class="ui-kk-toast__content">
      {{ props.content }}
    </div>
  </div>
</template>

<style lang="scss" src="./style.scss"></style>
